module.exports = __webpack_public_path__ + "static/media/RPR 1c.73cb0ba6.jpg";